import { ISelectValues } from "../../../../../component/ISelectValues";
import {getFilterValue} from "../../../../../utils/FilterUtils";

export const ID_FILTER_PAYMENT_TYPE = "paymentType";
export const ID_FILTER_AMOUNT_TYPE = "amountType";
export const ID_FILTER_STATUSES = "statuses";
export const ID_FILTER_STATUSES_OUTSTANDING = "statuses_outstanding";
export const ID_FILTER_INVOICE_DATE_FROM = "invoiceDateFrom";
export const ID_FILTER_INVOICE_DATE_TO = "invoiceDateTo";
export const ID_FILTER_DUE_DATE_FROM = "dueDateFrom";
export const ID_FILTER_DUE_DATE_TO = "dueDateTo";
export const ID_FILTER_SAP_INVOICE_NUMBER = "sapInvoiceNumber";
export const ID_FILTER_CUSTOMER_ID = "customerId";
export const ID_FILTER_CUSTOMER_NAME = "customerName";
export const ID_FILTER_CUSTOMER_LASTNAME = "customerLastName";
export const ID_FILTER_COMPANY_NAME = "companyName";
export const ID_FILTER_AMOUNT_FROM = "amountFrom";
export const ID_FILTER_AMOUNT_TO = "amountTo";
export const ID_FILTER_PAYMENT_MODE = "paymentMode";
export const ID_FILTER_PAN_CARD = "maskeredPan";
export const ID_FILTER_CREATIONDATEFROM = 'fromCreationDate';
export const ID_FILTER_CREATIONDATETO = 'toCreationDate';
export const ID_FILTER_MODIFICATIONDATEFROM = 'fromModificationDate';
export const ID_FILTER_MODIFICATIONDATETO = 'toModificationDate';
export const ID_PREAUTH_IS_RELEASED = 'preauthIsReleased';
export const ID_FILTER_CORRELATION_NAME = "correlationName";
export const ID_FILTER_CORRELATION_ID = "correlationId";
export const ID_FILTER_LASTTRANSACTIONDATEFROM = 'fromTransactionDate';
export const ID_FILTER_LASTTRANSACTIONDATETO = 'toTransactionDate';
export const ID_FILTER_INVOICE_NUMBER = 'invoiceNumber';
export const ID_FILTER_RELEASED_AMOUNT_FROM = 'releasedAmountFrom';
export const ID_FILTER_RELEASED_AMOUNT_TO = 'releasedAmountTo';
export const ID_FILTER_RETRY_MADE = 'retryMade';
export const ID_FILTER_LEGAL_ENTITIES = 'legalEntities';
export const ID_FILTER_DEALERS = 'dealers';
export const correlationName: ISelectValues[] = [
  {
    value: "SUBSCRIPTION",
    label: "types.SUBSCRIPTION",
  },
  {
    value: "MOBILITY VOUCHER",
    label: "types.MOBILITY_VOUCHER",
  },
  {
    value: "AMAZON VOUCHER",
    label: "types.AMAZON_VOUCHER",
  },
  {
    value: "PRE_PAID",
    label: "types.PRE_PAID",
  },
  {
    value: "RA",
    label: "types.RA",
  },
  {
    value: "DRIVALIA_RECHARGE",
    label: "types.DRIVALIA_RECHARGE"
  }
];

export const paymentTypes: ISelectValues[] = [
  {
    value: "J",
    label: "types.CREDITCARD",
  },
  {
    value: "D",
    label: "types.DEBITCARD",
  },
  {
    value: "B",
    label: "types.BANKTRANSFER",
  },
  {
    value: "P",
    label: "types.AMAZON",
  },
  {
    value: "A",
    label: "types.AMEXSOF",
  }
];

export const outstandingTypes: ISelectValues[] = [
  {
    value: "J",
    label: "types.CREDITCARD",
  },
  {
    value: "A",
    label: "types.AMEXSOF",
  }
];

export const paymentTMode: ISelectValues[] = [
  {
    value: "POS",
    label: "types.POS",
  },
  {
    value: "VIRTUAL",
    label: "types.VIRTUAL",
  }
];

export const amountTypes: ISelectValues[] = [
  {
    value: "PRE_AUTH",
    label: "types.PRE_AUTH",
  },
  {
    value: "PAY",
    label: "types.PAY",
  },
  {
    value: "REFUND",
    label: "types.REFUND",
  },
  {
    value: "PAY_PRE_AUTH",
    label: "types.PAY_PRE_AUTH",
  }
];

const BLUE = "secondary.transparent";
const PINK = "accent.transparent";
const YELLOW = "warning.transparent";
const GREY = "neutral.light";
const GREEN = "success.transparent";
const RED = "error.transparent";

export const statuses: (ISelectValues & {hiddenInFilters?: boolean}) [] = [
  {
    value: "OPENED",
    label: "statuses.OPENED",
    color: GREY,
  },
  {
    value: "RELEASED",
    label: "statuses.RELEASED",
    color: GREY,
  },
  {
    value: "IN_PROCESS",
    label: "statuses.IN_PROCESS",
    color: YELLOW,
  },
  {
    value: "ACCOUNTED",
    label: "statuses.ACCOUNTED",
    color: GREEN,
  },
  {
    value: "UNPAID",
    label: "statuses.UNPAID",
    color: RED,
  },
  {
    value: "TO_SEND",
    label: "statuses.TO_SEND",
    color: PINK,
  },
  {
    value: "TO_PAY",
    label: "statuses.TO_PAY",
    color: BLUE,
  },
  {
    value: "PAID",
    label: "statuses.PAID",
    color: GREEN,
  },
  {
    value: "TO_RETRY",
    label: "statuses.TO_RETRY",
    color: BLUE,
  },
  {
    value: "UNMANAGED",
    label: "statuses.UNMANAGED",
    color: GREY,
    hiddenInFilters: true
  },
  {
    value: "OUTSTANDING",
    label: "statuses.OUTSTANDING",
    color: RED,
  },
  {
    value: "SUSPENDED",
    label: "statuses.SUSPENDED",
    color: GREY,
  },
  {
    value: "EXTERNAL_MANAGEMENT",
    label: "statuses.EXTERNAL_MANAGEMENT",
    color: YELLOW,
  }
];

export const outstanding_statuses: ISelectValues[] = [
  {
    value: "OUTSTANDING",
    label: "statuses.OUTSTANDING",
    color: RED,
  },
  {
    value: "SUSPENDED",
    label: "statuses.SUSPENDED",
    color: GREY,
  },
  {
    value: "ACCOUNTED",
    label: "statuses.ACCOUNTED",
    color: GREEN,
  },
  {
    value: "EXTERNAL_MANAGEMENT",
    label: "statuses.EXTERNAL_MANAGEMENT",
    color: YELLOW,
  }
];
export const ID_FILTERTO_PAID = "TO_PAY";
export const ID_FILTER_TO_RETRY = "TO_RETRY";
export const ID_FILTER_SUSPENDED = "SUSPENDED";
export const ID_FILTER_UNPAID = "UNPAID";
export const ID_FILTER_ACCOUNTED = "ACCOUNTED";
export const ID_FILTER_EXTERNAL_MANAGEMENT = "EXTERNAL_MANAGEMENT";
export const ID_FILTER_OUTSTANDING = "OUTSTANDING";
export const getSummaryFields = () => {
  return [
    "PAID",
    "TO_PAY",
    "TO_RETRY",
    "UNPAID"
  ];
}

export const getOutstandingSummaryFields = () => {
  return [
    "OUTSTANDING",
    "SUSPENDED",
    "EXTERNAL_MANAGEMENT",
    "ACCOUNTED"
  ];
}

export const convertTypology = (type: ISelectValues[], value: string) => {
  const item = type.find((item) => item.value === value);
  return item ? item.label : "";
}

export const checkProductType = (correlationName: string) => {
  if (correlationName && correlationName.toUpperCase().includes("MOBILITY VOUCHER")) {
    return "MOBILITY VOUCHER";
  } else if (correlationName && correlationName.toUpperCase().includes("AMAZON VOUCHER")) {
    return "AMAZON VOUCHER";
  } else return correlationName;
}

export const convertAmountType = (type: ISelectValues[], value: string, usePreAuth: boolean) => {
  if (value == "PAY" && usePreAuth) {
    return "types.PAY_PRE_AUTH";
  } else {
    const item = type.find((item) => item.value === value);
    return item ? item.label : "";
  }

}



export const checkCorrelationName = (params : any, t: any) =>{
  let productType = "---";
  let raCode = params.data.raCode;
  if (raCode){
    productType = "RA";
  }
  let cName = params.value;
  if (cName && cName.includes(":")){
    cName = cName.substring(0, cName.indexOf(":"));
  }
  let typology = convertTypology(correlationName, checkProductType(cName));
  typology = typology ? t(typology) : "---";
  return params.value ?  typology :  productType;
}

export const checkCorrelationID = (params : any, t: any) =>{
  let productId = "---";
  let raCode = params.data.raCode;
  let correlationId = params.data.correlationId;
  if (!correlationId && raCode){
    productId = raCode.includes(",") ? "---" : raCode;
  }
  return params.value ? params.value :  productId;
}

export const customDefaultValues = {
  [ID_FILTER_PAYMENT_TYPE]: "",
  [ID_FILTER_PAYMENT_MODE]: "",
  [ID_FILTER_AMOUNT_TYPE]: [],
  [ID_FILTER_STATUSES]: [],
  [ID_FILTER_AMOUNT_FROM]: "",
  [ID_FILTER_AMOUNT_TO]: "", 
  [ID_FILTER_DUE_DATE_FROM]: null,
  [ID_FILTER_DUE_DATE_TO]: null,
  [ID_FILTER_INVOICE_DATE_FROM]: null,
  [ID_FILTER_INVOICE_DATE_TO]: null,
  [ID_FILTER_SAP_INVOICE_NUMBER]: "",
  [ID_FILTER_CUSTOMER_ID]: "",
  [ID_FILTER_PAN_CARD]: "",
  [ID_FILTER_CREATIONDATEFROM]: null,
  [ID_FILTER_CREATIONDATETO]: null,
  [ID_FILTER_MODIFICATIONDATEFROM]: null,
  [ID_FILTER_MODIFICATIONDATETO]: null,
  [ID_FILTER_CUSTOMER_NAME]: "",
  [ID_FILTER_CUSTOMER_LASTNAME]: "",
  [ID_FILTER_COMPANY_NAME]: "",
  [ID_FILTER_CORRELATION_NAME]: [],
  [ID_FILTER_CORRELATION_ID]: "",
  [ID_FILTER_LASTTRANSACTIONDATEFROM]: null,
  [ID_FILTER_LASTTRANSACTIONDATETO]: null,
  [ID_FILTER_INVOICE_NUMBER]: "",
  [ID_FILTER_RELEASED_AMOUNT_FROM]: "",
  [ID_FILTER_RELEASED_AMOUNT_TO]: "",
  [ID_FILTER_RETRY_MADE]: "",
  [ID_FILTER_DEALERS]:[]
};

export const customDefaultValuesOutstanding = {
  [ID_FILTER_PAYMENT_TYPE]: "",
  [ID_FILTER_PAYMENT_MODE]: "",
  [ID_FILTER_AMOUNT_TYPE]: [],
  [ID_FILTER_STATUSES_OUTSTANDING]: [],
  [ID_FILTER_AMOUNT_FROM]: "",
  [ID_FILTER_AMOUNT_TO]: "",
  [ID_FILTER_DUE_DATE_FROM]: null,
  [ID_FILTER_DUE_DATE_TO]: null,
  [ID_FILTER_INVOICE_DATE_FROM]: null,
  [ID_FILTER_INVOICE_DATE_TO]: null,
  [ID_FILTER_SAP_INVOICE_NUMBER]: "",
  [ID_FILTER_CUSTOMER_ID]: "",
  [ID_FILTER_PAN_CARD]: "",
  [ID_FILTER_CREATIONDATEFROM]: null,
  [ID_FILTER_CREATIONDATETO]: null,
  [ID_FILTER_MODIFICATIONDATEFROM]: null,
  [ID_FILTER_MODIFICATIONDATETO]: null,
  [ID_FILTER_CUSTOMER_NAME]: "",
  [ID_FILTER_CUSTOMER_LASTNAME]: "",
  [ID_FILTER_COMPANY_NAME]: "",
  [ID_FILTER_CORRELATION_NAME]: [],
  [ID_FILTER_CORRELATION_ID]: "",
  [ID_FILTER_INVOICE_NUMBER]: "",
  [ID_FILTER_LASTTRANSACTIONDATEFROM]: null,
  [ID_FILTER_LASTTRANSACTIONDATETO]: null,
  [ID_FILTER_DEALERS]:[]
};
